import { Form } from 'react-bootstrap';
import { BookingRequestRead, StatusByProviderEnum, StatusByRepEnum } from '../../../api';
import { useCurrencyFormatter } from '../../hooks/use-currency-formatter';
import { useDateFormatter } from '../../hooks/use-date-formatter';
import { TooltippedText } from '../TooltippedText';
import { getBookingDurationOutput } from './BookingRequestDialog.utils';

interface BookingTableProps {
  bookings: BookingRequestRead['bookings'];
  bookingRequest: BookingRequestRead;
  userIsProvider: boolean;
  allowShiftEdit: (
    booking: BookingRequestRead['bookings'][0],
    userIsProvider: boolean,
    bookingRequest: BookingRequestRead
  ) => boolean;
  register: any;
  setValue: any;
}

export const BookingTable = ({
  bookings,
  bookingRequest,
  userIsProvider,
  allowShiftEdit,
  register,
  setValue,
}: BookingTableProps) => {
  const { formatDate } = useDateFormatter();
  const { formatCurrencyPostfix } = useCurrencyFormatter({ postfix: '/hr' });
  return (
    <table className="table table-striped table-hover">
      <thead className="sticky-top top-0">
        <tr>
          <th>Date & Time</th>
          <th>Hours</th>
          <th colSpan={2}>Rate</th>
        </tr>
      </thead>
      <tbody>
        {bookings?.map((booking, index) => {
          return (
            <tr
              key={booking.id}
              className={
                booking.status_by_provider === StatusByProviderEnum.REJECTED ||
                booking.status_by_rep === StatusByRepEnum.REJECTED
                  ? 'text-decoration-line-through'
                  : ''
              }
            >
              <td>
                {booking.start_on === booking.end_on ? (
                  <TooltippedText
                    tooltipContent={
                      booking.status_by_provider === StatusByProviderEnum.REJECTED
                        ? 'Shift rejected by the provider'
                        : booking.status_by_rep === StatusByRepEnum.REJECTED
                        ? 'Shift rejected by the representative'
                        : undefined
                    }
                  >
                    {formatDate(booking.start_on)}, {booking.start_time.slice(0, -3)} -{' '}
                    {booking.end_time.slice(0, -3)}
                    <input type="text" className="d-none" {...register(`bookings.${index}.id`)} />
                  </TooltippedText>
                ) : (
                  <TooltippedText
                    tooltipContent={
                      booking.status_by_provider === StatusByProviderEnum.REJECTED
                        ? 'Shift rejected by the provider'
                        : booking.status_by_rep === StatusByRepEnum.REJECTED
                        ? 'Shift rejected by the representative'
                        : undefined
                    }
                  >
                    {formatDate(booking.start_on)}, {booking.start_time.slice(0, -3)} -{' '}
                    {formatDate(booking.end_on)}, {booking.end_time.slice(0, -3)}
                    <input type="text" className="d-none" {...register(`bookings.${index}.id`)} />
                  </TooltippedText>
                )}
                {booking.is_overtime && (
                  <TooltippedText tooltipContent="Overtime">
                    <span className="ms-2 bg-info fw-semibold cursor-pointer p-1 small rounded-2 text-white">
                      OT
                    </span>
                  </TooltippedText>
                )}
              </td>
              <td>{getBookingDurationOutput(booking)}</td>
              <td>{formatCurrencyPostfix(booking.provider_rate)}</td>

              {userIsProvider && (
                <td className="text-end">
                  <Form.Check
                    disabled={!allowShiftEdit(booking, userIsProvider, bookingRequest)}
                    {...register(`bookings.${index}.status_by_provider`)}
                    onChange={(e) => {
                      setValue(e.target.name, e.target.checked);
                    }}
                  />
                </td>
              )}
              {!userIsProvider && (
                <td className="text-end">
                  <Form.Check
                    disabled={!allowShiftEdit(booking, userIsProvider, bookingRequest)}
                    {...register(`bookings.${index}.status_by_rep`)}
                    onChange={(e) => {
                      setValue(e.target.name, e.target.checked);
                    }}
                  />
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
